





import { defineComponent, ref } from "@vue/composition-api";
import { ActiveRecording, recordAudio } from "@/lib/mediaRecord";

const AUDIO_MAX_DURATION = 60000;
const AUDIO_MIN_DURATION = 1000;

export default defineComponent({
  name: "AudioRecordingController",
  setup(props, ctx) {
    const activeRecording = ref<Promise<ActiveRecording> | null>(null);
    const durationMs = ref(0);
    let timerId: ReturnType<typeof setInterval>;
    const recording = ref(false);

    const stopRecord = async () => {
      if (activeRecording.value) {
        const audioFile = await (await activeRecording.value).stop();
        ctx.emit("stoppedRecord");
        recording.value = false;
        if (durationMs.value > AUDIO_MIN_DURATION) {
          ctx.emit("input", audioFile);
        }
        activeRecording.value = null;
        clearInterval(timerId);
        durationMs.value = 0;
      }
    };
    const startRecord = async () => {
      activeRecording.value = recordAudio();
      await activeRecording.value;
      ctx.emit("startedRecord");
      recording.value = true;
      if (timerId) {
        clearInterval(timerId);
      }
      timerId = setInterval(() => {
        durationMs.value += 1000;
        if (durationMs.value > AUDIO_MAX_DURATION) {
          stopRecord();
        }
      }, 1000);
    };

    return { recording, durationMs, startRecord, stopRecord };
  },
});
